<template>
  <app-layout>
    <v-card class="ma-3 pa-3">
      <!-- Resume -->
      <v-card-title class="pt-0">
        <v-layout row wrap>
          <v-flex xs12>
            <v-layout align-start justify-center column fill-height>
              <div>
                <h2>Configuración</h2>
              </div>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-card-title>
      <v-card-text>
        <v-tabs v-model="selectedTab" fixed-tabs>
          <v-tabs-slider color="yellow"></v-tabs-slider>
          <v-tab v-for="tab in tabs" :key="`title-tab-${tab}`" class="pa-3">
            {{ tab }}
          </v-tab>
        </v-tabs>
        <v-tabs-items v-model="selectedTab">
          <v-tab-item key="content-tab-0">
            <v-card flat>
              <v-card-text>
                <h3 class="text-xs-center">
                  Indica los datos fiscales que aparecerán en tus presupuestos y facturas
                </h3>
                <v-form ref="settingsForm" class="mt-5">
                  <v-layout row wrap>
                    <v-flex xs12 md8 offset-md2>
                      <v-layout row wrap>
                        <v-flex xs12 md6 class="pa-3">
                          <v-text-field
                            v-model="settingsForm.name"
                            :rules="[rules.required]"
                            label="Nombre"
                            required
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs12 md6 class="pa-3">
                          <v-text-field
                            v-model="settingsForm.cif"
                            :rules="[rules.required]"
                            label="NIF/CIF"
                            required
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs12 md6 class="pa-3">
                          <v-text-field
                            v-model="settingsForm.address"
                            :rules="[rules.required]"
                            label="Dirección"
                            required
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs12 md6 class="pa-3">
                          <v-text-field
                            v-model="settingsForm.city"
                            :rules="[rules.required]"
                            label="Ciudad"
                            required
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs12 md6 class="pa-3">
                          <v-text-field
                            v-model="settingsForm.postal_code"
                            :rules="[rules.required]"
                            label="Código postal"
                            required
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs12 md6 class="pa-3">
                          <v-text-field
                            v-model="settingsForm.province"
                            :rules="[rules.required]"
                            label="Provincia"
                            required
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs12 md6 class="pa-3">
                          <v-text-field
                            v-model="settingsForm.country"
                            :rules="[rules.required]"
                            label="País"
                            required
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs12 md6 class="pa-3">
                          <v-select
                            v-model="settingsForm.sector"
                            :items="sectors"
                            item-text="text"
                            item-value="value"
                            label="Sector"
                          ></v-select>
                        </v-flex>
                        <v-flex xs12 md6 class="pa-3">
                          <v-text-field
                            v-model="settingsForm.email"
                            :rules="[]"
                            label="Email"
                            required
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs12 md6 class="pa-3">
                          <v-text-field
                            v-model="settingsForm.phone"
                            :rules="[]"
                            label="Teléfono"
                            required
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs12 md6 class="pa-3">
                          <v-select
                            class="pr-2"
                            v-model="settingsForm.default_payment_method"
                            :items="availablePaymentMethods"
                            item-text="text"
                            item-value="value"
                            label="Método de pago por defecto"
                          ></v-select>
                        </v-flex>
                        <v-flex xs12 md6 class="pa-3">
                          <v-text-field
                            class="pl-2"
                            v-model="settingsForm.account_iban"
                            :rules="[]"
                            label="Cuenta bancaria - IBAN"
                            required
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-form>
              </v-card-text>
            </v-card>
            <v-layout row wrap>
              <v-flex xs12 md8 offset-md2>
                <v-layout align-center justify-center row fill-height>
                  <div>
                    <v-btn depressed color="primary" @click="saveSettingsForm()">Guardar</v-btn>
                  </div>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-tab-item>
          <v-tab-item key="content-tab-1">
            <v-card flat>
              <v-card-text>
                <h3 class="text-xs-center">
                  Añade el logotipo que se mostrará en tus presupuestos y facturas de venta.
                </h3>
                <v-form ref="settingsForm" class="mt-5">
                  <v-layout row wrap>
                    <v-flex xs12 md8 offset-md2 class="pa-3">
                      <v-img :src="logo" max-height="200px" contain></v-img>
                      <file-pond
                        class="mt-5"
                        name="logo"
                        ref="pond"
                        label-idle="Sube tu logotipo aquí"
                        :storeAsFile="true"
                        accepted-file-types="image/jpeg, image/png"
                        labelInvalidField="El fichero seleccionado no es compatible"
                        credits=""
                      />
                    </v-flex>
                  </v-layout>
                </v-form>
              </v-card-text>
            </v-card>
            <v-layout row wrap>
              <v-flex xs12 md8 offset-md2>
                <v-layout align-center justify-center row fill-height>
                  <div>
                    <v-btn depressed color="primary" @click="saveLogoForm()">Guardar</v-btn>
                  </div>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-tab-item>
          <v-tab-item key="content-tab-2">
            <v-card flat>
              <v-card-text>
                <h3 class="text-xs-center">
                  Configura las series que puedes utilizar en tus presupuestos y facturas
                </h3>
                <v-form ref="settingsForm" class="mt-5">
                  <v-layout row wrap>
                    <v-flex xs12 md8 offset-md2 class="pa-3">
                      <open-billing-series></open-billing-series>
                    </v-flex>
                  </v-layout>
                </v-form>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item key="content-tab-3">
            <v-card flat>
              <v-card-text>
                <h3 class="text-xs-center">
                  Si lo deseas, puedes configurar la información que quieres mostrar en el pie de
                  página de tus facturas
                </h3>
                <v-form ref="settingsForm" class="mt-5">
                  <v-layout row wrap>
                    <v-flex xs12 md8 offset-md2>
                      <v-layout row wrap>
                        <v-flex xs12 class="pl-3 pr-3">
                          <v-textarea
                            v-model="settingsForm.invoice_footer"
                            box
                            :rules="[]"
                          ></v-textarea>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-form>
              </v-card-text>
            </v-card>
            <v-layout row wrap>
              <v-flex xs12 md8 offset-md2>
                <v-layout align-center justify-center row fill-height>
                  <div>
                    <v-btn depressed color="primary" @click="saveSettingsForm()">Guardar</v-btn>
                  </div>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-tab-item>
        </v-tabs-items>
      </v-card-text>
    </v-card>
    <v-snackbar v-model="snack" bottom right :timeout="3000" :color="snackColor">
      {{ snackText }}
    </v-snackbar>
  </app-layout>
</template>

<script>
import AppLayout from '@/views/layouts/AppLayout';
import apiCtrl from '@/services/api/abstract/abstract-api';
// Import FilePond
import vueFilePond from 'vue-filepond';

// Import plugins
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type/dist/filepond-plugin-file-validate-type.esm.js';
import FilePondPluginImagePreview from 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.esm.js';

// Import styles
import 'filepond/dist/filepond.min.css';
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css';
import OpenBillingSeries from './OpenBillingSeries';

// Create FilePond component
const FilePond = vueFilePond(FilePondPluginFileValidateType, FilePondPluginImagePreview);

export default {
  name: 'OpenBillingSettings',
  components: {
    AppLayout,
    FilePond,
    'open-billing-series': OpenBillingSeries,
  },
  props: ['ownConsultant'],
  data() {
    return {
      tabs: ['Datos fiscales', 'Logotipo', 'Series', 'Datos adicionales'],
      selectedTab: 0,
      hasImage: false,
      snack: false,
      snackText: '',
      snackColor: 'info',
      rules: {
        required: value => !!value || 'Este campo es obligatorio.',
        counter: value => value.length <= 20 || 'Max 20 characters',
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || 'Email inválido';
        },
      },
      settingsForm: {
        id: null,
        clavedat: null,
        name: null,
        cif: null,
        address: null,
        city: null,
        postal_code: null,
        province: null,
        country: null,
        sector: null,
        account_iban: null,
        logo: null,
        default_payment_method: null,
        phone: null,
        email: null,
        invoice_footer: null,
      },
      logoForm: {
        new_logo: null,
      },
      sectors: [
        { text: 'Comercio', value: 'Comercio' },
        { text: 'Construcción', value: 'Construcción' },
        { text: 'Hostelería', value: 'Hostelería' },
        { text: 'Agricultura, ganadería y pesca', value: 'Agricultura, ganadería y pesca' },
        { text: 'Industria manufacturera', value: 'Industria manufacturera' },
        {
          text: 'Profesionales técnicos y científicos',
          value: 'Profesionales técnicos y científicos',
        },
        { text: 'Transporte y almacenamiento', value: 'Transporte y almacenamiento' },
        { text: 'Administrativos y servicios aux.', value: 'Administrativos y servicios aux.' },
        { text: 'Sanitarias y servicios sociales', value: 'Sanitarias y servicios sociales' },
        { text: 'Educación', value: 'Educación' },
        { text: 'Finanzas y seguros', value: 'Finanzas y seguros' },
        { text: 'Artísticas, recreat. y de entret.', value: 'Artísticas, recreat. y de entret.' },
        { text: 'Información y comunicación', value: 'Información y comunicación' },
        { text: 'Inmobiliaria', value: 'Inmobiliaria' },
        { text: 'Otros servicios', value: 'Otros servicios' },
      ],
      availablePaymentMethods: [
        { text: 'No definido', value: 'No definido' },
        { text: 'Efectivo', value: 'Efectivo' },
        { text: 'Bizum', value: 'Bizum' },
        { text: 'Transferencia', value: 'Transferencia' },
        { text: 'Tarjeta bancaria', value: 'Tarjeta bancaria' },
        { text: 'Domiciliación bancaria', value: 'Domiciliación bancaria' },
        { text: 'Paypal', value: 'Paypal' },
      ],
    };
  },
  mounted() {
    this.getSettings();
  },
  computed: {
    clavedat() {
      return this.$store.state.clavedat;
    },
    billingProfileId() {
      return this.$store.getters.currentOpenbillingProfileId;
    },
    logo() {
      return this.settingsForm.logo || '';
    },
  },
  methods: {
    showSnackMessage(action, message) {
      this.snackColor = action;
      this.snackText = message;
      this.snack = true;
    },
    saveSettingsForm() {
      apiCtrl
        .post(
          `/openbilling/${this.clavedat}/settings/update/${this.billingProfileId}`,
          this.settingsForm,
        )
        .then(res => {
          this.$store.commit('updateCurrentOpenbillingProfile', res.data.data);
          this.showSnackMessage('success', 'Datos guardados correctamente');
        })
        .catch(err => {
          this.showSnackMessage('error', 'Se ha producido un error al guardar los datos');
        });
    },
    saveLogoForm() {
      const file = this.$refs.pond.getFile();
      if (!file) {
        this.showSnackMessage('warning', 'No ha seleccionado ningún logo');
      } else {
        this.logoForm.new_logo = JSON.parse(JSON.stringify(file.file));
        let formdata = new FormData();
        formdata.append('new_logo', file.file);

        apiCtrl
          .postUpload(
            `/openbilling/${this.clavedat}/settings/update/logo/${this.billingProfileId}`,
            formdata,
          )
          .then(res => {
            this.settingsForm.logo = res.data.data.logo;
            this.$refs.pond.removeFile();
            this.$store.commit('updateCurrentOpenbillingProfile', res.data.data);
            this.showSnackMessage('success', 'Datos guardados correctamente');
          })
          .catch(err => {
            this.logoForm.new_logo = null;
            this.showSnackMessage('error', 'Se ha producido un error al guardar el logo');
          });
      }
    },
    getSettings() {
      apiCtrl
        .get(`/openbilling/${this.clavedat}/settings/show/${this.billingProfileId}`)
        .then(res => {
          const data = res.data.data;
          Object.keys(this.settingsForm).forEach(key => {
            this.settingsForm[key] = data[key];
          });
        });
    },
  },
  watch: {},
};
</script>

<style>
.custom-file-uploader {
  display: none !important;
}
</style>
